export default "__VITE_ASSET__CjyKszdh__"